import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";

const ModalCajaSalida = ({ estado, onCloseModal, item, onReturnValue, isnew }) => {
  const hoy = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    idcajasalida: "",
    articulo: "",
    cantidad: "",
    fecha: hoy,
    motivo: "",
    destino: "",
    observacion: "",
  });

  useEffect(() => {
    if (item) {
      setFormData({
        idcajasalida: item.idcajasalida || "",
        articulo: item.articulo || "",
        cantidad: item.cantidad || "",
        fecha: item.fecha ? item.fecha.split("T")[0] : hoy,
        motivo: item.motivo || "",
        destino: item.destino || "",
        observacion: item.observacion || "",
      });
    } else {
      setFormData({ idcajasalida: "", articulo: "", cantidad: "", fecha: hoy, motivo: "", destino: "", observacion: "" });
    }
  }, [item]);

  const set = (field) => (e) => setFormData({ ...formData, [field]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const upper = Object.fromEntries(
      Object.entries(formData).map(([k, v]) => [k, typeof v === "string" ? v.toUpperCase() : v])
    );
    onReturnValue({ ...upper, fecha: formData.fecha }, isnew);
  };

  return (
    <Modal show={estado} onHide={onCloseModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isnew ? "Agregar Salida" : "Editar Salida"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} id="formCajaSalida">
          <div className="form-group mb-3">
            <label className="form-label">Artículo <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control"
              required
              value={formData.articulo}
              onChange={set("articulo")}
              placeholder="Nombre del artículo"
            />
          </div>
          <div className="row">
            <div className="col-6 form-group mb-3">
              <label className="form-label">Cantidad <span className="text-danger">*</span></label>
              <input
                type="number"
                className="form-control"
                required
                min="1"
                value={formData.cantidad}
                onChange={set("cantidad")}
              />
            </div>
            <div className="col-6 form-group mb-3">
              <label className="form-label">Fecha <span className="text-danger">*</span></label>
              <input
                type="date"
                className="form-control"
                required
                value={formData.fecha}
                onChange={set("fecha")}
              />
            </div>
          </div>
          <div className="form-group mb-3">
            <label className="form-label">Motivo</label>
            <input
              type="text"
              className="form-control"
              value={formData.motivo}
              onChange={set("motivo")}
              placeholder="Motivo de la salida"
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label">Destino</label>
            <input
              type="text"
              className="form-control"
              value={formData.destino}
              onChange={set("destino")}
              placeholder="Destino del artículo"
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label">Observación</label>
            <textarea
              className="form-control"
              rows={2}
              style={{ resize: "none" }}
              value={formData.observacion}
              onChange={set("observacion")}
              placeholder="Detalle adicional..."
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>Cancelar</Button>
        <Button type="submit" form="formCajaSalida" variant="primary">Guardar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCajaSalida;
